<template>
  <div class="h100">
    <el-row style="height: 84%">
      <el-col :span="8" class="h100 question-title-box">
        <div class="index" v-if="currentQuestion">习题{{ currentIndex }}/{{ checksList.length }}</div>
        <div class="question" v-if="currentQuestion">
          <div v-html="currentQuestion.question"></div>
          <div v-if="currentQuestion.option">
            <div v-for="(oneOption,key) in currentQuestion.option">
              {{ key }}:&nbsp;&nbsp;<span v-html="oneOption"></span>
            </div>
          </div>
          <div style="margin-top:10px;" v-if="currentQuestion.analyze" v-html="currentQuestion.analyze"></div>
          <div v-if="currentQuestion.answer && currentQuestion.answer.length">
            <br/>
            【答案】
            <div v-for="ans in currentQuestion.answer" v-html="ans"></div>
          </div>
        </div>
      </el-col>
      <el-col :span="16" v-if="currentQuestion" class="right-box">
        <div class="student-answer-box flex flex-row-space-between " v-for="item in currentQuestion.results">
          <div class="left">
            <div class="tag">学生作答</div>
            <div>
              <template v-for="answer in item.answer">
                <div style="position: relative">
                  <img class="answer-img" :src="answer" :style="{'transform': 'rotate('+item.imageAngle+'deg)'}"
                       @click="enlargeImg(answer)"/>
                  <div class="img-operation-box">
                    <el-button icon="el-icon-refresh-right" circle type="primary"
                               @click="rotateItemImage(item)" title="图片旋转"></el-button>
                  </div>
                </div>

              </template>
            </div>
            <div>申诉理由：{{ item.reason }}</div>
          </div>
          <div class="right">
            <div class="check-box flex flex-wrap">
              <div class="title">批改</div>
              <div class="one-btn flex-col-h-center" v-for="(score, point) in item.examPoint2.detail">
                <el-checkbox :label="point+'('+currentQuestion.examPoint.detail[point]+')'"
                             v-model="item.examPoint2.detail[point]"></el-checkbox>
              </div>
              <div class="one-btn submit flex-col-h-center" :class="{isSubmit:item.isSubmit}"
                   @click="submitAnswer(currentQuestion, item)">
                确定
              </div>

            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row class="bottom-box">
      <el-col :span="24" class="direction-box flex-row-h-center flex-row-space-between">
        <el-button type="primary" :disabled="currentIndex==1" @click="goPrev()">上一题</el-button>
        <el-button type="primary" :disabled="currentIndex>=checksList.length" @click="goNext()">下一题</el-button>
      </el-col>
    </el-row>

    <el-dialog class="img-dialog" title="放大答案" :visible.sync="isOpenImageDialog">
      <img :src="imageUrl" :style="{'transform': 'rotate('+imageAngle+'deg)'}"/>
      <div class="flex flex-row-flex-end" style="margin-top: 10px;">
        <el-button icon="el-icon-refresh-right" circle type="primary" @click="rotateImage" title="图片旋转"></el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'advanceAppealReview',
  props: {
    isInitFlag: {
      type: Boolean,
    },
  },
  data() {
    return {
      checksList: [],
      currentIndex: 1,
      isOpenImageDialog: false,
      imageUrl: null,
      imageAngle: 0,
    };
  },
  computed: {
    currentQuestion() {
      if (this.checksList.length) {
        return this.checksList[this.currentIndex - 1];
      } else {
        return null;
      }
    },
  },
  methods: {
    init() {
      this.checksList = [];
      this.currentIndex = 1;
      this.getReviews();
    },
    // 获取申诉审核列表
    getReviews() {
      this.axios.get('/bank/test/v1.0/reviews/appeal').then((res) => {
        if (res.data.code == 200) {
          let list = res.data.data;
          list.forEach(question => {
            question.results.forEach(oneResult => {
              if (!oneResult.examPoint2) {
                oneResult.examPoint2 = {detail: {}};
              }
              for (const pointKey in question.examPoint.detail) {
                oneResult.examPoint2.detail[pointKey] = !!oneResult.examPoint.detail[pointKey];
              }
            });
            question.answer.forEach(ans => {
              ans = ans.replace(/\r\n/g, "<br/>");
            })
          });
          this.checksList = list;
        }
      });
    },
    submitAnswer(question, item, isOk) {
      let total = 0;
      // 赋分
      item.examPoint = {detail: {}};
      for (const pointKey in item.examPoint2.detail) {
        if (item.examPoint2.detail[pointKey]) {
          item.examPoint.detail[pointKey] = question.examPoint.detail[pointKey];
          total += item.examPoint.detail[pointKey];
        } else {
          item.examPoint.detail[pointKey] = 0;
        }
      }
      item.examPoint.total = total;
      this.axios.put(`/bank/test/v1.0/reviews/problems/${item.problemId}/check-complain`, {
        'type': item.type,
        'score': total,
        'examPoint': item.examPoint,
        'id': item.id,
      }).then(res => {
        this.$set(item, 'isSubmit', true);
      });
    },

    rotateItemImage(item) {
      if (!item.imageAngle) {
        item.imageAngle = 0;
      }
      item.imageAngle += 90;
      this.$forceUpdate();
    },
    enlargeImg(imgUrl) {
      this.imageUrl = imgUrl;
      this.imageAngle = 0;
      this.isOpenImageDialog = true;
    },
    rotateImage() {
      this.imageAngle += 90;
    },
    goPrev() {
      this.currentIndex--;
    },
    goNext() {
      this.currentIndex++;
    },
  },
  watch: {
    isInitFlag(newValue, oldValue) {
      if (newValue != oldValue) {
        this.init();
      }
    },
  },
};
</script>

<style scoped>
.h100 {
  height: 100%;
}

.question-title-box {
  border-right: 1px solid rgba(187, 187, 187, 100);
  padding: 10px 15px;
  overflow-y: auto;
}

.question-title-box .index {
  color: #101010;
  font-weight: bold;
  margin-bottom: 20px;
}

.direction-box {
  border-top: 1px solid rgba(187, 187, 187, 100);
  padding: 20px 10px;
}

.right-box {
  height: 100%;
  overflow-y: auto;
}

.student-answer-box {
  padding: 30px 30px;
  border-bottom: 1px solid rgba(187, 187, 187, 100);
  align-items: flex-start;
  position: relative;
  box-sizing: border-box;
  align-items: flex-end;
}

.student-answer-box:last-child {
  border-bottom: none;
}

.student-answer-box .left {
  width: 80%;
  padding-right: 30px;
  min-height: 200px;
}

/*.student-answer-box .right {*/
/*  position: absolute;*/
/*  height: 100%;*/
/*  right:20px;*/
/*  bottom: 40px;*/
/*}*/

.student-answer-box .answer-img {
  width: 100%;
  cursor: pointer;
  margin-bottom: 10px;
}

.student-answer-box .img-operation-box {
  position: absolute;
  right: 10px;
  top: 10px;
}

.student-answer-box .tag {
  width: 85px;
  height: 24px;
  line-height: 24px;
  border-radius: 9px;
  background-color: rgba(40, 191, 148, 100);
  color: rgba(255, 255, 255, 100);
  text-align: center;
  margin-bottom: 20px;
}


.check-box {
  width: 100px;
  /*position: absolute;*/
  /*right: 20px;*/
  /*top: 10px;*/
  /*z-index: 2;*/
}

.check-box .title {
  height: 33px;
  line-height: 33px;
  background-color: rgba(81, 165, 247, 100);
  color: rgba(255, 255, 255, 100);
  text-align: center;
}

.check-box .one-btn {
  height: 48px;
  text-align: center;
  border: 1px solid rgba(187, 187, 187, 100);
  cursor: pointer;
  margin-top: -1px;
}

.check-box .one-btn.submit {
  cursor: pointer;
  color: #75BD75;
}

.check-box .one-btn.submit.isSubmit {
  color: #fff;
  background-color: #67c23a;
}

.bottom-box {
  height: 10%;
  background: #fff;
}

.text-success {
  color: #67C23A;
}

.text-danger {
  color: #F56C6C;
}

.img-dialog {

}

.img-dialog img {
  width: 100%;
}
</style>
